<template>
  <div class="granularity-toggle" role="group" :aria-label="ariaLabel">
    <button
      v-for="opt in options"
      :key="opt.key"
      type="button"
      class="granularity-btn"
      :class="{ active: modelValue === opt.key }"
      :aria-pressed="modelValue === opt.key"
      @click="$emit('update:modelValue', opt.key)"
    >
      {{ opt.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'GranularityToggle',
  props: {
    modelValue: { type: String, required: true },
    options: { type: Array, required: true }, // [{ key, label }]
    ariaLabel: { type: String, default: 'Time granularity' },
  },
  emits: ['update:modelValue'],
};
</script>

<style scoped>
.granularity-toggle {
  display: inline-flex;
  gap: 2px;
  background: var(--page-plane, #f2f2ef);
  border: 1px solid var(--border, rgba(11, 11, 11, 0.10));
  border-radius: 8px;
  padding: 3px;
}

.granularity-btn {
  border: none;
  background: transparent;
  color: var(--text-secondary, #52514e);
  font-size: 12.5px;
  font-weight: 600;
  padding: 5px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.granularity-btn:hover {
  color: var(--text-primary, #0b0b0b);
}

.granularity-btn.active {
  background: var(--surface-1, #fff);
  color: var(--series-1, #2a78d6);
  box-shadow: 0 1px 2px rgba(11, 11, 11, 0.08);
}
</style>
